import { MyProfile, MyProfileErrorCode } from 'common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { MyProfileDataSelector } from './MyProfileDataSelector';
import { fetchMyProfile } from './MyProfileSlice';

export function useMyProfile(): AbstractDataState<MyProfile, MyProfileErrorCode> {
    return useGetSimpleApiData(fetchMyProfile, MyProfileDataSelector);
}
